import Link, { LinkProps } from 'next/link';
import { AnchorHTMLAttributes, FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import useRouteNavigation from '@/utils/hooks/useRouteNavigation';

export interface TextLinkProps
	extends LinkProps,
		Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps>,
		TClassNameProps {
	withUnderlineAnimation?: boolean;
	wrapperClassName?: string;
	children?: ReactNode;
	className?: string;
}

const CustomNextLink: FC<TextLinkProps> = (props) => {
	const { href, withUnderlineAnimation = true, wrapperClassName = '', target, className, ...otherProps } = props;
	const nextHref = href as unknown;
	const { startProgress } = useRouteNavigation();

	return (
		<div className={twMerge(`text-link-animated flex ${wrapperClassName}`)}>
			<Link
				href={nextHref as URL}
				className={twMerge(`${withUnderlineAnimation ? 'withAnimation' : ''} w-full ${className}`)}
				onClick={(event) => {
					if (!(event?.ctrlKey || event?.metaKey)) {
						const { pathname, search, hash } = window.location;
						const currentPath = pathname + search + hash;
						if (href !== currentPath) {
							startProgress();
						}
					}
				}}
				prefetch={true}
				target={target}
				{...otherProps}
				aria-label="Supra Logo"
			/>
		</div>
	);
};

export default CustomNextLink;
